<template>
  <div
    class="flex items-center justify-between py-2 px-4 gap-2 md:bg-alpha-black-10 border md:border-alpha-white-20 rounded-md shadow-xs"
  >
    <label class="flex items-center grow gap-2">
      <Icon
        name="search"
        class="shrink-0 text-alpha-black-80 md:fg-disabled_subtle"
        aria-hidden
      />
      <input
        class="w-full flex items-center justify-center grow p-0.5 bg-inherit border-none text-style-sm font-medium text-alpha-black-80 md:text-alpha-white-80 md:placeholder:text-placeholder_subtle placeholder:truncate focus:ring-0"
        :value="query"
        @input="
          $emit(
            'update:query',
            $event?.target?.value ? $event.target.value : ''
          )
        "
        :placeholder="$t('components.inputs.type_to_search')"
        type="text"
        name="search"
        id="search"
        @click.stop
      />
    </label>
    <div>
      <Button
        v-show="query"
        :label="$t('components.buttons.cancel')"
        variant="link"
        size="xs"
        class="md:text-alpha-white-80 text-alpha-black--60 text-sm"
        @click.stop="$emit('update:query', '')"
      />
      <Icon
        v-if="maxSmall"
        name="close"
        v-show="!query"
        class="shrink-0 md:text-alpha-white-80 text-alpha-black--60"
        :aria-label="$t('components.buttons.close')"
        @click.stop="$emit('close')"
      />
    </div>
  </div>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["update:query", "close"]);

defineProps({
  query: { type: String, default: "" },
});
</script>
